import { takeEvery, put, call } from 'redux-saga/effects'
import { ADMIN_ORGANIZATION_USERS_RESEND_INVITE } from '../actionTypes'
import { adminOrganizationUsersResendInvite } from '../actions'
// @ts-ignore
import makeAPIRequest from 'store/entities/api/sagas'
// @ts-ignore
import { POST_ADMIN_ORGANIZATION_RESEND_INVITE_PATH } from 'app/constants/api/organizations'
// @ts-ignore
import { showSuccess } from 'store/entities/toastr/utils'

export default function* resendInviteSaga() {
  yield takeEvery(ADMIN_ORGANIZATION_USERS_RESEND_INVITE.POST.REQUEST, handleResendInviteRequest)
}

export function* handleResendInviteRequest({ payload: { data } }: any) {
  const { email, id, organizationId, phone } = data
  try {
    // uncomment and remove delay when https://github.com/gsogol/prohabits-backend/issues/211 is finished
    yield call(makeAPIRequest, POST_ADMIN_ORGANIZATION_RESEND_INVITE_PATH, {
      method: 'POST',
      data: {
        email,
        phone,
        organizationId,
      },
    })
    id
      ? yield put(adminOrganizationUsersResendInvite.post.success(id))
      : showSuccess({ content: 'Invitation sent successfully' })
  } catch (badResponse) {
    console.log(badResponse)
    yield put(adminOrganizationUsersResendInvite.post.fail(id))
  }
}
